/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.0.0",
  "gitBuildTime": "2024-08-30T14:28:10.721Z",
  "gitBuildVersion": "2.0.0",
  "gitCommitId": "acfc457",
  "gitCommitIdFull": "acfc4570b60795b98f15d9b878792dfc83ef7bd9",
  "gitCommitTime": "2024-08-30T14:26:53.000Z",
  "version": "2.0.0-2024-08-30T14:26:53.000Z-(acfc457)"
};
